import { SideNavState } from '../models/side-nav-state.model';

// Side nav State
export const LEFT_SIDE_NAVIGATION: SideNavState[] = [
  {
    title: 'Getting Started',
    basePath: '/getting-started',
    active: false
  },
  {
    title: 'Atlas UI Migration',
    basePath: '/atlas-ui-migration',
    active: false
  },
  {
    title: 'Components',
    basePath: '/components',
    expand: true,
    active: true,
    children: [
      {
        title: 'Overview',
        route: '/components/overview'
      },
      {
        title: 'Banners',
        route: '/components/banners'
      },
      {
        title: 'Breadcrumbs',
        route: '/components/breadcrumbs'
      },
      {
        title: 'Buttons',
        route: '/components/buttons'
      },
      {
        title: 'Cards',
        route: '/components/cards'
      },
      {
        title: 'Checkbox',
        route: '/components/checkbox'
      },
      {
        title: 'Chips',
        route: '/components/chips'
      },
      {
        title: 'CTA Footer',
        route: '/components/cta-footer'
      },
      {
        title: 'Datepicker',
        route: '/components/datepicker'
      },
      {
        title: 'Dialogs',
        route: '/components/dialogs'
      },
      {
        title: 'Expansion Panels',
        route: '/components/expansion-panels'
      },
      {
        title: 'Left Side Navigation',
        route: '/components/left-side-navigation'
      },
      {
        title: 'Menus',
        route: '/components/menus'
      },
      {
        title: 'Radio Buttons',
        route: '/components/radio-buttons'
      },
      {
        title: 'Search',
        route: '/components/search'
      },
      {
        title: 'Select',
        route: '/components/select'
      },
      {
        title: 'Spinner',
        route: '/components/spinner'
      },
      {
        title: 'Tabs',
        route: '/components/tabs'
      },
      {
        title: 'Text Input',
        route: '/components/text-input'
      },
      {
        title: 'Textarea',
        route: '/components/textarea'
      },
      {
        title: 'Timepicker',
        route: '/components/timepicker'
      },
      {
        title: 'Toggle Switch',
        route: '/components/toggle-switch'
      },
      {
        title: 'Tooltips',
        route: '/components/tooltips'
      },
      {
        title: 'Top Navigation',
        route: '/components/top-navigation'
      }
    ]
  },
  {
    title: 'Utilities',
    basePath: '/utilities',
    expand: false,
    active: false,
    children: [
      {
        title: 'Auth',
        route: '/utilities/auth'
      },
      {
        title: 'Crypto',
        route: '/utilities/crypto'
      },
    ]
  },
  {
    title: 'Foundations',
    basePath: '/foundations',
    expand: false,
    active: false,
    children: [
      {
        title: 'Accessibility',
        route: '/foundations/accessibility'
      },
      {
        title: 'Color and Usage',
        route: '/foundations/color-and-usage'
      },
      {
         title: 'Design Tokens',
         route: '/foundations/design-tokens'
       },
      {
        title: 'Layout',
        route: '/foundations/layout'
      },
      {
        title: 'Logo',
        route: '/foundations/logo'
      },
      {
        title: 'Theming',
        route: '/foundations/theming'
      },
      {
        title: 'Typography',
        route: '/foundations/typography'
      },
      {
        title: 'Iconography',
        route: '/foundations/iconography'
      }
    ]
  },
  {
    title: 'Patterns',
    basePath: '/patterns',
    expand: false,
    active: false,
    children: [
      {
        title: 'Overview',
        route: '/patterns/overview/'
      },
      {
        title: 'Confirmation',
        route: '/patterns/confirmation'
      },
      {
        title: 'Data Tables',
        route: '/patterns/data-tables'
      },
      {
        title: 'Empty States',
        route: '/patterns/empty-states'
      },
      {
        title: 'Navigation',
        route: '/patterns/navigation'
      }
    ]
  },
  {
    title: 'FAQs',
    basePath: '/faqs',
    active: false,
  },
  // {
  //   title: 'Contribution',
  //   basePath: '/contribution'
  // }
];
